import { BaseMapper, normalizeValue } from '@ps/utils';
import { MultiCountry } from '@ps/survey-kernel';

import { MultiCountryDto, SurveyDto } from '../dtos/invoice-survey.dto';
import { Survey } from '../../models/invoice-survey.model';

export class SurveyMapper extends BaseMapper<SurveyDto, Survey> {
  public fromDto(dto: SurveyDto): Survey {
    const mc = normalizeValue(dto.mc);

    return {
      averageCpi: dto.average_cpi,
      billingId: dto.billing_id,
      bip: dto.bip,
      companyName: dto.company_name,
      completesRequired: dto.completes_required,
      currencySymbol: dto.currency_symbol,
      currentIncidence: dto.current_incidence,
      fielded: dto.fielded,
      id: dto.ps_survey_id,
      localization: dto.survey_localization,
      ...(mc && { multiCountry: this._mapMultiCountry(mc) }),
      status: dto.ps_survey_status,
      title: dto.survey_title,
    };
  }

  private _mapMultiCountry(
    mc: Partial<MultiCountryDto>,
  ): Partial<MultiCountry> {
    return {
      svp: mc.SVP,
      parent: mc.parent,
      surveys: mc.surveys?.map((s) => ({
        ...s,
        languageShortCode: s.languageCode,
      })),
    };
  }
}
